import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { LogofSmsEmailSentService } from '../../business-services/logof-sms-email-sent.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { UserDataService } from 'src/app/DataServices/user-data.service';

@Component({
  selector: 'app-mechanic',
  templateUrl: './logof-sms-email-sent.component.html',
  styleUrls: ['./logof-sms-email-sent.component.css']
})
export class LogofSmsEmailSentComponent implements OnInit, OnDestroy {
  //#region Declaration
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  lstCommunication: any[];
  lstDealers: any[];
  commRequestModel: any = {
    userId: '',
    fromToDate: '',
    dealerId: '',
    channelType: 'SELECT',
    status: 0,
    startRecordNo: 0,
    noOfRecord: 25,
    sortColumn: 'OnDate',
    sortDirection: 'DESC',
    workOrderNo: ''
  };
  lstChannelType: { id: string, label: string }[] = [
    { id: 'SELECT', label: 'lblSelect' },
    { id: 'EMAIL', label: 'lblEmail' },
    { id: 'SMS', label: 'lblSms' },
    { id: 'PUSHNOTIFICATION', label: 'lblPushNotification' }
  ];
  lstStatusType: string[] = ["","Success","Failed","Pending"];
  totalCount: number = 0;
  throttle = 100;
  scrollDistance = 1;
  communicationDetail: any;

  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  isTodayViewOn: boolean = true;
  isWeekViewOn: boolean = false;
  createdDate: any[];
  //#endregion

  //#region Constructor & Init
  constructor(private dealerBusinessService: DealerBusinessService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private logofSmsEmailSentService: LogofSmsEmailSentService,
    private activeModal: NgbActiveModal,
    private datePipe: DatePipe,
    private userService: UserDataService
  ) { }

  ngOnInit(): void {
    this.commRequestModel.StartRecordNo = 0;
    this.commRequestModel.dealerId = this.userService.currentUserValue.defaultDealerId;
    this.lstCommunication = [];
    this.totalCount = 0;
    this.getUserDealers();
    this.loadTodayView();
  }
  ngOnDestroy(): void {
    this.commRequestModel = null;
    this.lstCommunication = [];
    this.totalCount = 0;
  }
  //#endregion

  //#region Page Method
  async onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.commRequestModel.SortColumn = column;
    this.commRequestModel.SortDirection = direction;
    await this.GetCommunicationList();
  }
  onScrollDown(_ev) {
    if (this.totalCount > this.lstCommunication.length) {
      this.commRequestModel.StartRecordNo = this.lstCommunication.length;
      this.GetCommunicationList(false);
    }
  }
  loadTodayView() {
    this.isTodayViewOn = true;
    this.isWeekViewOn = false;
    let todays_date = new Date();

    const weekViewDate = this.datePipe.transform(todays_date, 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(todays_date, 'dd/MM/yyyy');
    this.createdDate=[];
    this.createdDate.push(todays_date);
    this.createdDate.push(todays_date);
    const todayViewDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    this.commRequestModel.fromToDate = todayViewDate;
    this.GetCommunicationList();
  }
  loadWeekView() {
    this.isTodayViewOn = false;
    this.isWeekViewOn = true;
    
    let current = new Date();
    let startDay = 1; //0=sunday, 1=monday etc.
    let d = current.getDay(); //get the current day
    let weekStart = new Date(current.valueOf() - (d <= 0 ? 7 - startDay : d - startDay) * 86400000); //rewind to start day
    let weekEnd = new Date(weekStart.valueOf() + 6 * 86400000); //add 6 days to get last day
    const weekViewDate = this.datePipe.transform(weekStart, 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(weekEnd, 'dd/MM/yyyy');
    this.createdDate=[];
    this.createdDate.push(weekStart);
    this.createdDate.push(weekEnd);
    this.commRequestModel.fromToDate = weekViewDate;
    this.GetCommunicationList();
  }
  onDealerSelected(dealerId: string) {
    this.commRequestModel.dealerId = !dealerId ? '' : dealerId;
    this.GetCommunicationList();
  }
  onDateRangeChanged(event: any) {
    this.createdDate= (typeof event === 'undefined') ? [] : event;
    let createdDateFormatted= this.getFormattedDate(this.createdDate);
    if (createdDateFormatted == "") {
      this.loadTodayView();
    }
    else{
      this.GetCommunicationList();
    }
  }
  onChannelChange() {
    this.GetCommunicationList();
  }
  onStatusChange() {
    this.GetCommunicationList();
  }
  onClickChangeView(isWeek: boolean) {
    if (isWeek) {
      this.loadWeekView()
    } else {
      this.loadTodayView()
    }
  }
  OnClose() {
    this.activeModal.close({ success: false });
  }
  ViewDetails(viewDetailContent, com) {
    this.communicationDetail = com;
    let modalRef = this.modalService.open(viewDetailContent, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
    modalRef.result.then(() => {
      this.communicationDetail = null;
    });
  }
  monthDiff(d1: any, d2: any) {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth();
    // edit: increment months if d2 comes later in its month than d1 in its month
    if (d2.getDate() >= d1.getDate())
      months++
    // end edit
    return months <= 0 ? 0 : months;
  }
  getLocalDate(date){
    return new Date(date+"Z");
  }
  //#endregion

  //#region API Method
  async getUserDealers() {
    this.spinner.show();
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      let array = response.userDealersModel;
      let supperArray = [];
      if (array && array.length > 0) {
        array.forEach(element => {
          let single = Object();
          single.value = element.dealerId
          single.text = element.dealerName

          supperArray.push(single);
        })
      }
      this.lstDealers = supperArray;
      if(this.lstDealers.length === 1){
        this.commRequestModel.dealerId = this.lstDealers[0].value;
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }
  async GetCommunicationList(isRefresh: boolean = true) {
    let createdDateFormatted= this.getFormattedDate(this.createdDate);
    this.commRequestModel.fromToDate = createdDateFormatted ?? "";
    if (isRefresh) {
      this.commRequestModel.StartRecordNo = 0;
      this.lstCommunication = [];
      this.totalCount = 0;
    }
    this.spinner.show();
    await this.logofSmsEmailSentService.GetCommunicationList(this.commRequestModel).then((res) => {
      if (res.responseObject?.length > 0) {
        this.lstCommunication.push(...res.responseObject);
        this.totalCount = this.lstCommunication[0].totalCount;
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }
  //#endregion
  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}
